module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-9"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pgContent"
  }, [(_vm.ableUp == 1) ? _c('el-upload', {
    ref: "upload",
    attrs: {
      "disabled": "upState == 'loading'",
      "accept": ".doc,docx",
      "disabled": _vm.upState == 'loading',
      "action": _vm.postUrl,
      "before-upload": _vm.prevCtrls,
      "on-progress": _vm.pgressCtrls,
      "on-error": _vm.errorCtrls,
      "on-success": _vm.successCtrls,
      "on-remove": _vm.removeCtrls,
      "show-file-list": false,
      "data": _vm.fileData,
      "multiple": "",
      "on-exceed": _vm.handleExceed
    }
  }, [_c('el-button', [(_vm.upState == 'loaded') ? _c('span', [_vm._v("更新分析报告")]) : (_vm.upState == 'loading') ? _c('span', [_vm._v("上传中 "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _c('span', [_vm._v("上传分析报告")])])], 1) : _vm._e(), _vm._v(" "), (_vm.ableUp == 1) ? _c('div', {
    staticClass: "flieList"
  }, [_c('a', {
    attrs: {
      "href": _vm.fileUrl,
      "download": ""
    }
  }, [_vm._v(_vm._s(_vm.fileName))])]) : _vm._e(), _vm._v(" "), (_vm.ableUp == 2) ? _c('el-button', [_c('a', {
    attrs: {
      "href": _vm.fileUrl,
      "download": ""
    }
  }, [_vm._v("下载分析报告")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('el-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upState == 'loading'),
      expression: "upState == 'loading'"
    }],
    staticClass: "progressBox",
    attrs: {
      "stroke-width": 9,
      "percentage": _vm.percentage
    }
  })], 1), _vm._v(" "), (_vm.ableUp == 3) ? _c('div', {
    staticClass: "pvcTips"
  }, [_vm._v("已上报至总局")]) : _vm._e()], 1), _vm._v(" "), (_vm.ableUp == 1) ? _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goAdmin
    }
  }, [_vm._v("上报国家新闻出版署")])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("出版连续型电子出版物单位上报")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27843505"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/provinceRole/successivePgress/successiveReport.vue
// module id = 1695
// module chunks = 1